import { render, staticRenderFns } from "./EventIcons.vue?vue&type=template&id=2effeed5&"
import script from "./EventIcons.vue?vue&type=script&lang=js&"
export * from "./EventIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports